import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import TextInput from '../../../../../common/components/TextInput';
import RssFeedCRUDActions from "@mm/state/actions/RssFeedCRUDActions";
import './RssFeedDetails.scss';

const UrlTextInput = ({ url, onUrlChange, updateFeed, errors }) =>
  <div className="feed-details__input-container">
    <div className="feed-details__ad-name-container">
      <div className="feed-details__field-title">RSS Feed</div>
      <TextInput
        placeholder="RSS Feed"
        className="feed-details__feed-name"
        maxLength="600"
        onChange={onUrlChange}
        onBlur={updateFeed}
        onMouseLeave={updateFeed}
        value={url}
      />
      <span className="feed-details__error">{ errors.url }</span>
    </div>
  </div>;

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFeed: () => {
    const { feed, chatbotId, validate } = ownProps;
    const url = ownProps.url && ownProps.url.trim();
    if (feed.url !== url) {
      validate({ url });
      const newFeed = Object.assign({}, feed, { url });
      return dispatch(RssFeedCRUDActions.update(chatbotId, newFeed));
    }
    return null;
  },
})

const onUrlChange = ({ setUrl }) => e => setUrl(e.target.value || '');

const enhance = compose(
  withState('url', 'setUrl', ({ feed: { url } }) => url),
  withState('validationMessage', 'setValidationMessage', ''),
  withHandlers({ onUrlChange }),
  connect(null, mapDispatchToProps),
);

export default enhance(UrlTextInput);
